import { render, staticRenderFns } from "./leftfour.vue?vue&type=template&id=f47b8e3a&scoped=true&"
import script from "./leftfour.vue?vue&type=script&lang=js&"
export * from "./leftfour.vue?vue&type=script&lang=js&"
import style0 from "./leftfour.vue?vue&type=style&index=0&id=f47b8e3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47b8e3a",
  null
  
)

export default component.exports